export default (variableName: string) => {
	return getComputedStyle(document.documentElement).getPropertyValue(variableName).trim()
}
